import { createContext } from "react";

export const useToken = createContext("");
